import { iconStyle } from './MapVectorStyles.js';
import Feature from 'ol/Feature';
import Point from 'ol/geom/Point';

const IconFeature = (props) => {
    const { x, y, icon, color, info, data, poi=true } = props;
    const coords = [x, y];

    const iconFeat = new Feature({
        geometry: new Point(coords),
        poi,
        info,
        data
    });

    iconFeat.setStyle(iconStyle(icon, color));
    return iconFeat;
};
export default IconFeature;
